export const FIREBASE_CONSTANTS = {
    // https://firebase.google.com/docs/firestore/query-data/queries#in_not-in_and_array-contains-any
    WHERE_IN_MAX_LENGTH: 30,
    ARRAY_CONTAINS_MAX_LENGTH: 30,
    LIMIT_DISJUNCTIVE_CLAUSES: 30,
};